import {hexToRgb} from './colors';

const toLinear = (channel: number) => {
  const c = channel / 255;
  return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
};

export const isLightBackground = (backgroundHex: string | undefined): boolean | undefined => {
  const rgb = hexToRgb(backgroundHex);
  if (!rgb) {
    return undefined;
  }

  const [r, g, b] = rgb;
  const luminance = 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);

  return luminance > 0.179;
};
